import { type ReactNode, useState } from 'react';

import ArrowDown from '@/components/icons/ArrowDown';

interface IAccordionV2 {
  title: string;
  subTitle?: string;
  children: ReactNode;
  className?: string;
  expanded?: boolean;
  hideArrow?: boolean;
}
export const AccordionV2: React.FC<IAccordionV2> = ({
  title,
  children,
  expanded = false,
  hideArrow = false,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(expanded);

  return (
    <div {...rest}>
      <button
        className={`w-full ${hideArrow ? 'cursor-default' : ''}`}
        type="button"
        onClick={!hideArrow ? () => setIsOpen(!isOpen) : undefined}
      >
        <div className="flex w-full justify-between">
          <span className="whitespace-nowrap text-left font-interBold text-base md:font-interSemibold md:text-base lg:text-sm xl:text-base">
            {title}
          </span>
          {!hideArrow && (
            <ArrowDown
              fill=""
              style={{
                transform: `${isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}`,
                flexShrink: '0',
              }}
            />
          )}
        </div>
      </button>
      <div className={isOpen ? ' py-4 ' : 'hidden'}>{children}</div>
    </div>
  );
};
